/**
 * ITSD module route definitions.
 *
 * Exports lazy-loaded page components and route paths for the
 * IT Service Desk module. Consumed by the dynamic module route
 * loader in routes/index.tsx via import.meta.glob.
 *
 * Cross-References:
 *   - FR-ITSD-001: Ticket CRUD
 *   - FR-ITSD-005: SLA tracking
 *   - Sprint IT1: IT Service Desk Foundation
 */
import { lazy } from 'react';

// Sprint ITSD-4: MyTickets replaces the legacy TicketList stub at
// /modules/itsd/tickets. The legacy TicketList component file stays
// on disk (no public route) until the next cleanup pass.
const MyTickets = lazy(() => import('./pages/MyTickets'));
const TicketDetail = lazy(() => import('./pages/TicketDetail'));
// Sprint ITSD-8 — SLADashboard retired; the /sla path now lands on
// the rebuilt Service Desk Metrics page (Jira-sourced CSAT + Created
// vs Resolved + TTR panels). URL stable for backward compatibility.
const ServiceDeskMetrics = lazy(() => import('./pages/ServiceDeskMetrics'));
// Sprint ITSD-9 — Operational Status: aggregated upstream-SaaS health
// (Atlassian / M365 / Google Workspace / Box / HubSpot / UptimeRobot
// + curated catalog of well-known providers).
const OperationalStatus = lazy(() => import('./pages/OperationalStatus'));
const OperationalStatusAdmin = lazy(
  () => import('./pages/OperationalStatusAdmin'),
);

export const slug = 'itsd';

export const routes = [
  { path: 'tickets', element: MyTickets },
  { path: 'tickets/:id', element: TicketDetail },
  { path: 'sla', element: ServiceDeskMetrics },
  { path: 'status', element: OperationalStatus },
  { path: 'status/admin', element: OperationalStatusAdmin },
];
